/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  const calendarValuePositions = new Map([
    ['jan', 0], ['january', 0],
    ['feb', 1], ['february', 1],
    ['mar', 2], ['march', 2],
    ['apr', 3], ['april', 3],
    ['may', 4],
    ['jun', 5], ['june', 5],
    ['jul', 6], ['july', 6],
    ['aug', 7], ['august', 7],
    ['sep', 8], ['sept', 8], ['september', 8],
    ['oct', 9], ['october', 9],
    ['nov', 10], ['november', 10],
    ['dec', 11], ['december', 11]
  ]);
  const zodiacValuePositions = new Map([
    ['aries', 0],
    ['taurus', 1],
    ['gemini', 2],
    ['cancer', 3],
    ['leo', 4],
    ['virgo', 5],
    ['libra', 6],
    ['scorpio', 7],
    ['sagittarius', 8],
    ['capricorn', 9],
    ['aquarius', 10],
    ['pisces', 11]
  ]);

  function normalizeVariantButtonValue(value) {
    return value.trim().toLowerCase();
  }

  function normalizeVariantButtonHandle(value) {
    return normalizeVariantButtonValue(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u2018\u2019']/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getVariantButtonValue(button) {
    const optionInput = button.matches('input[value]')
      ? button
      : button.querySelector('input[value]');

    return optionInput ? normalizeVariantButtonValue(optionInput.value) : null;
  }

  function getVariantButtonValueId(button) {
    const optionInput = button.matches('[data-option-value-id]')
      ? button
      : button.querySelector('[data-option-value-id]');

    return optionInput ? optionInput.getAttribute('data-option-value-id') : null;
  }

  function getVariantButtonHandle(button) {
    const optionInput = button.matches('input[value]')
      ? button
      : button.querySelector('input[value]');

    return optionInput ? normalizeVariantButtonHandle(optionInput.value) : null;
  }

  function getVariantButtonGroupKey(group) {
    const optionInput = group.querySelector('[name]');

    return optionInput ? optionInput.getAttribute('name') : null;
  }

  function getSemanticVariantButtonPositions(buttons) {
    const values = buttons.map(getVariantButtonValue);

    if (!values.length || values.some(function(value) { return !value; })) {
      return null;
    }

    if (values.every(function(value) { return calendarValuePositions.has(value); })) {
      return calendarValuePositions;
    }

    if (values.every(function(value) { return zodiacValuePositions.has(value); })) {
      return zodiacValuePositions;
    }

    if (values.every(function(value) { return /^-?\d+(?:\.\d+)?$/.test(value); })) {
      return new Map(
        values.map(function(value) {
          return [value, Number(value)];
        })
      );
    }

    return null;
  }

  function getConfiguredVariantButtonPositions(group, buttons) {
    const configuredOrder = group.getAttribute('data-variant-order-handles');

    if (!configuredOrder) {
      return null;
    }

    const handles = configuredOrder
      .split('|')
      .map(function(handle) { return handle.trim(); })
      .filter(Boolean);
    const positions = new Map();

    for (const handle of handles) {
      if (positions.has(handle)) {
        return null;
      }

      positions.set(handle, positions.size);
    }

    const matchedButtons = buttons.filter(function(button) {
      const handle = getVariantButtonHandle(button);
      return handle && positions.has(handle);
    });

    return matchedButtons.length > 1 ? positions : null;
  }

  function getPreferredVariantButtonPositions(group, buttons) {
    const configuredPositions = getConfiguredVariantButtonPositions(group, buttons);

    if (configuredPositions) {
      return {
        positions: configuredPositions,
        getButtonKey: getVariantButtonHandle
      };
    }

    const semanticPositions = getSemanticVariantButtonPositions(buttons);

    return semanticPositions
      ? {positions: semanticPositions, getButtonKey: getVariantButtonValue}
      : null;
  }

  function sortVariantButtons(group, positions, getButtonKey) {
    const buttons = Array.from(group.children).map(function(button, index) {
      return {button: button, index: index};
    });

    buttons.sort(function(firstItem, secondItem) {
      const firstKey = getButtonKey(firstItem.button);
      const secondKey = getButtonKey(secondItem.button);
      const firstPosition = positions.has(firstKey)
        ? positions.get(firstKey)
        : Number.MAX_SAFE_INTEGER;
      const secondPosition = positions.has(secondKey)
        ? positions.get(secondKey)
        : Number.MAX_SAFE_INTEGER;

      return firstPosition - secondPosition || firstItem.index - secondItem.index;
    });

    buttons.forEach(function(item) {
      group.appendChild(item.button);
    });
  }

  function normalizeRecognizedVariantButtonGroups(selector) {
    selector.querySelectorAll('[data-variant-buttons]').forEach(function(group) {
      const buttons = Array.from(group.children);
      const preferredOrder = getPreferredVariantButtonPositions(group, buttons);

      if (preferredOrder) {
        sortVariantButtons(group, preferredOrder.positions, preferredOrder.getButtonKey);
      }
    });
  }

  function preserveVariantButtonOrder(currentSelector, incomingSelector) {
    const mainProduct = currentSelector.closest('product-info[id^="MainProduct--"]');

    if (!mainProduct) {
      return;
    }

    const currentGroups = Array.from(currentSelector.querySelectorAll('[data-variant-buttons]'));
    const incomingGroups = Array.from(incomingSelector.querySelectorAll('[data-variant-buttons]'));
    const currentGroupsByKey = new Map();

    currentGroups.forEach(function(group) {
      const groupKey = getVariantButtonGroupKey(group);

      if (groupKey) {
        currentGroupsByKey.set(groupKey, group);
      }
    });

    incomingGroups.forEach(function(incomingGroup) {
      const groupKey = getVariantButtonGroupKey(incomingGroup);
      const currentGroup = groupKey ? currentGroupsByKey.get(groupKey) : null;

      if (!currentGroup) {
        return;
      }

      const incomingButtons = Array.from(incomingGroup.children);
      const preferredOrder = getPreferredVariantButtonPositions(incomingGroup, incomingButtons);

      if (preferredOrder) {
        sortVariantButtons(incomingGroup, preferredOrder.positions, preferredOrder.getButtonKey);
        return;
      }

      const currentOrder = Array.from(currentGroup.children)
        .map(getVariantButtonValueId)
        .filter(Boolean);
      const orderByValueId = new Map(
        currentOrder.map(function(valueId, index) {
          return [valueId, index];
        })
      );
      sortVariantButtons(incomingGroup, orderByValueId, getVariantButtonValueId);
    });
  }

  function installVariantButtonOrderPreserver() {
    const htmlUpdateUtility = window.HTMLUpdateUtility;

    if (!htmlUpdateUtility || typeof htmlUpdateUtility.viewTransition !== 'function') {
      return false;
    }

    const originalViewTransition = htmlUpdateUtility.viewTransition;

    if (originalViewTransition.preservesVariantButtonOrder) {
      return true;
    }

    function viewTransitionWithStableVariantOrder(oldNode, newContent) {
      if (
        oldNode instanceof Element &&
        newContent instanceof Element &&
        oldNode.matches('variant-selects') &&
        newContent.matches('variant-selects')
      ) {
        preserveVariantButtonOrder(oldNode, newContent);
      }

      return originalViewTransition.apply(this, arguments);
    }

    viewTransitionWithStableVariantOrder.preservesVariantButtonOrder = true;
    htmlUpdateUtility.viewTransition = viewTransitionWithStableVariantOrder;

    return true;
  }

  if (!installVariantButtonOrderPreserver()) {
    document.addEventListener('DOMContentLoaded', installVariantButtonOrderPreserver, {once: true});
  }

  document.querySelectorAll('product-info[id^="MainProduct--"] variant-selects').forEach(function(selector) {
    normalizeRecognizedVariantButtonGroups(selector);
  });

  function renderOmnisendButtonLabel(textNode, buttonText) {
    const parts = buttonText.split('|').map(function(part) {
      return part.trim();
    });

    if (parts.length === 2) {
      textNode.classList.add('btn__text--omnisend-trigger');
      textNode.innerHTML = '<span class="product__omnisend-label">' + parts[0] + '</span><span class="product__omnisend-separator" aria-hidden="true">✉</span><span class="product__omnisend-label">' + parts[1] + '</span>';
      return;
    }

    textNode.classList.remove('btn__text--omnisend-trigger');
    textNode.textContent = buttonText;
  }

  function syncOmnisendBackInStockButtons(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const buttons = root.querySelectorAll('[data-omnisend-form-id][data-omnisend-button-text]');

    buttons.forEach(function(button) {
      const formId = button.getAttribute('data-omnisend-form-id');
      const notifyText = button.getAttribute('data-omnisend-button-text');
      const formWrapper = button.closest('.show-product-notification');
      const isCartBarButton = button.closest('.cart-bar__submit');
      const textNode = button.querySelector('[data-add-to-cart-text], .btn__text');
      const soldOut = formWrapper && (
        formWrapper.classList.contains('variant--soldout') ||
        (isCartBarButton && formWrapper.classList.contains('all-variants--soldout'))
      );

      button.removeAttribute('style');

      if (textNode) {
        textNode.removeAttribute('style');
        textNode.classList.remove('btn__text--omnisend-trigger');
      }

      if (!soldOut) {
        button.removeAttribute('data-omnisend-open-form');
        button.disabled = false;

        if (button.getAttribute('type') === 'button' && button.hasAttribute('data-add-to-cart')) {
          button.setAttribute('type', 'submit');
        }

        return;
      }

      button.setAttribute('data-omnisend-open-form', formId);
      button.disabled = false;

      if (button.hasAttribute('data-add-to-cart')) {
        button.setAttribute('type', 'button');
      }

      if (textNode) {
        renderOmnisendButtonLabel(textNode, notifyText);
      }
    });
  }

  function openOmnisendForm(formId) {
    if (!formId) {
      return;
    }

    if (window.omnisend && typeof window.omnisend.push === 'function') {
      window.omnisend.push(['openForm', formId]);
      return;
    }

    console.warn('Omnisend form trigger unavailable for form:', formId);
  }

  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-omnisend-open-form]');

    if (!trigger) {
      return;
    }

    event.preventDefault();
    openOmnisendForm(trigger.getAttribute('data-omnisend-open-form'));
  });

  document.addEventListener('DOMContentLoaded', function() {
    syncOmnisendBackInStockButtons(document);
  });

  if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS && window.theme.PUB_SUB_EVENTS.variantChange) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function() {
      syncOmnisendBackInStockButtons(document);
    });
  }

  if (window.location.pathname.includes('/products/')) {
    document.addEventListener('DOMContentLoaded', function () {
      const accordions = Array.from(document.querySelectorAll('.product__block--accordion details.accordion'));

      if (!accordions.length) {
        return;
      }

      const openAccordion = accordions.find((accordion) => accordion.open);
      const defaultAccordion = openAccordion || accordions[0];

      if (!openAccordion) {
        defaultAccordion.open = true;

        const accordionBody = defaultAccordion.querySelector('[data-collapsible-body]');

        if (accordionBody) {
          accordionBody.style.height = 'auto';
        }
      }

      accordions.forEach((accordion) => {
        accordion.addEventListener('toggle', function () {
          if (accordion.open) {
            accordions.forEach((otherAccordion) => {
              if (otherAccordion !== accordion) {
                otherAccordion.open = false;
              }
            });
          }
        });
      });
    });
  }
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
